import { render, staticRenderFns } from "./BaseConfirmModal.vue?vue&type=template&id=535fa0a4&scoped=true"
import script from "./BaseConfirmModal.vue?vue&type=script&lang=js"
export * from "./BaseConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./BaseConfirmModal.vue?vue&type=style&index=0&id=535fa0a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535fa0a4",
  null
  
)

export default component.exports